/**
 * Hält Preis und Verfügbarkeit im Whisky-Finder mit Shopify synchron.
 * Die Produktdaten im Seitentemplate bleiben als Ausfallsicherung erhalten.
 */
(function () {
  const FALLBACK_PRICES = {
    '/products/kilkerran-heavily-peated-batch-10-campbeltown-single-malt-57-8-vol': 67.9,
    '/products/kilkerran-heavily-peated-batch-13-58-6-vol': 67.9,
    '/products/kilkerran-heavily-peated-batch-14': 67.9,
    '/products/kilkerran-12-years-old-campbeltown-single-malt-scotch-whisky-46-vol': 59.9,
    '/products/kilkerran-8-jahre-cask-strength-campbeltown-single-malt': 82.9,
    '/products/hazelburn-10-years-old-campbeltown-single-malt-scotch-whisky-46-vol': 84.9,
    '/products/products-hazelburn-8-jahre-sauternes': 139,
  };

  const PRODUCT_URL_ALIASES = {
    '/products/kilkerran-12-years-old-campbeltown-single-malt-scotch-whisky-46-vol-tube':
      '/products/kilkerran-12-years-old-campbeltown-single-malt-scotch-whisky-46-vol',
    '/products/kilkerran-heavily-peated-batch-13':
      '/products/kilkerran-heavily-peated-batch-13-58-6-vol',
    '/products/kilkerran-8-years-cask-strength':
      '/products/kilkerran-8-jahre-cask-strength-campbeltown-single-malt',
    '/products/hazelburn-10-years':
      '/products/hazelburn-10-years-old-campbeltown-single-malt-scotch-whisky-46-vol',
    '/products/hazelburn-sauternes-8-jahre-springbank-campbeltown-single-malt-scotch-whisky-0-7-l':
      '/products/products-hazelburn-8-jahre-sauternes',
  };

  function productEndpoint(productUrl) {
    const cleanUrl = productUrl.split('?')[0].replace(/\/$/, '');
    return `${cleanUrl}.js`;
  }

  async function loadProduct(whisky) {
    whisky.url = PRODUCT_URL_ALIASES[whisky.url] || whisky.url;

    if (FALLBACK_PRICES[whisky.url] !== undefined) {
      whisky.preis = FALLBACK_PRICES[whisky.url];
    }

    const response = await fetch(productEndpoint(whisky.url), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`Produkt konnte nicht geladen werden: ${whisky.url}`);
    }

    const product = await response.json();
    const firstAvailableVariant = product.variants?.find((variant) => variant.available);
    const displayVariant = firstAvailableVariant || product.variants?.[0];

    whisky.verfuegbar = Boolean(product.available);
    whisky.preis = Number(displayVariant?.price ?? product.price) / 100;
    whisky.name = product.title || whisky.name;
  }

  function setButtonLoading(button, loading) {
    if (!button) return;

    if (loading) {
      button.dataset.originalLabel = button.textContent.trim();
      button.textContent = 'Aktuelle Produkte werden geladen …';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      return;
    }

    button.textContent = button.dataset.originalLabel || 'Meinen Whisky finden';
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }

  async function syncFinderProducts() {
    const finder = document.querySelector('#avw-finder');
    if (!finder || typeof avwWhiskys === 'undefined' || !Array.isArray(avwWhiskys)) return;

    const button = finder.querySelector('button[onclick*="avwWhiskyFinden"]');
    setButtonLoading(button, true);

    await Promise.allSettled(avwWhiskys.map(loadProduct));

    for (let index = avwWhiskys.length - 1; index >= 0; index -= 1) {
      if (avwWhiskys[index].verfuegbar === false) {
        avwWhiskys.splice(index, 1);
      }
    }

    setButtonLoading(button, false);

    const result = document.querySelector('#avw-ergebnis');
    if (result?.style.display === 'block' && typeof avwWhiskyFinden === 'function') {
      avwWhiskyFinden(true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFinderProducts, { once: true });
  } else {
    syncFinderProducts();
  }
})();
